export default __webpack_public_path__ + "static/media/Users.5c77dd50.svg";